import React, { useState } from "react";
import { Navbar, Nav,  Container, Button, Modal, Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import logo from '../../assets/Zarinova-logo.png';
import './Navbar.css';

const NavbarComponent = () => {
  const [showModal, setShowModal] = useState(false);
  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);

  return (
    <>
      <Navbar expand="lg" className="navbar-dark bg-black position-fixed w-100 z-3">
        <Container>
          <Navbar.Brand as={Link} to="/" className="fw-bold text-white">
            <img src={logo} alt="Zarinova Logo" className="navbar-logo" />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto align-items-center gap-3">
              <Nav.Link href="/"  rel="noopener noreferrer" className="text-white">HOME</Nav.Link>
<Nav.Link href="/about"  rel="noopener noreferrer" className="text-white">ABOUT US</Nav.Link>
   <Nav.Link href="/services"  rel="noopener noreferrer" className="text-white">SERVICES</Nav.Link>           

            
              <Nav.Link href="/gallery"  rel="noopener noreferrer" className="text-white">GALLERY</Nav.Link>
              
              <Nav.Link href="/video"  rel="noopener noreferrer" className="text-white">UP COMMING EVENT</Nav.Link>
              <Nav.Link href="/contact"  rel="noopener noreferrer" className="text-white">CONTACT</Nav.Link>

              <Button onClick={handleShow} className="learn-more-btn rounded-pill px-4 py-2 text-white">
                Book Now
              </Button>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* Booking Modal */}
      <Modal show={showModal} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Book an Event</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3" controlId="formName">
              <Form.Label>Name</Form.Label>
              <Form.Control type="text" placeholder="Enter your name" />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formEmail">
              <Form.Label>Email address</Form.Label>
              <Form.Control type="email" placeholder="Enter email" />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formDate">
              <Form.Label>Event Date</Form.Label>
              <Form.Control type="date" />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formDetails">
              <Form.Label>Event Details</Form.Label>
              <Form.Control as="textarea" rows={3} />
            </Form.Group>

            <Button variant="primary1" className="learn-more-btn rounded-pill px-4 py-2 text-white" onClick={handleClose}>
              Submit Booking
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default NavbarComponent;
